export default {
  generic: {
    success: {
      text: 'Successful',
      type: 'info',
    },
    error: {
      text: 'Oops something went wrong, please try again',
      type: 'warning',
    },
  },
  // Form Errors (vuelidate)
  formValidation: {
    required: (field) => `${field} is required `,
    minLength: (field, number) => `${field} needs to be at least ${number.min} characters`,
    maxLength: (field, number) => `${field} exceeds the ${number.max} character limit for SMS.`,
    minValue: (field) => `${field} cannot be in the past`,
  },
  emailAutomationLists: {
    noData: {
      heading: 'No E-mail Automation Lists created',
      message: 'You haven\'t created any E-mail Automation Lists. Click Create E-mail Automation List to get started',
    },
  },
  // Messages
  message: {
    create: {
      success: (name) => ({
        text: `${name} created`,
        type: 'info',
      }),
      error: {
        text: 'Something went wrong please try again',
        type: 'warning',
      },
    },
    update: {
      success: (name) => ({
        text: `${name} updated`,
        type: 'info',
      }),
    },
  },
  shortCodes: {
    success: {
      text: 'Custom field copied',
      type: 'info',
    },
    error: {
      text: 'Oops something went wrong, please try again',
      type: 'warning',
    },
  },
};
